import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from './Layout';
import './Coupons.css';

const Coupons = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('weight-loss');
  const [coupons, setCoupons] = useState([]);
  const [bulkCoupons, setBulkCoupons] = useState([]);
  const [filteredCoupons, setFilteredCoupons] = useState([]);
  const [filteredBulkCoupons, setFilteredBulkCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bulkLoading, setBulkLoading] = useState(true);
  const [error, setError] = useState('');
  const [bulkError, setBulkError] = useState('');
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showBulkCreateForm, setShowBulkCreateForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [bulkSearchTerm, setBulkSearchTerm] = useState('');
  const [createForm, setCreateForm] = useState({
    code: '',
    discount_type: 'percentage',
    discount_value: '',
    expiry_date: '',
    coupon_code_type: 'multiple',
    coupon_code_single_user_onetime: 0,
    minimum_purchase_amount: ''
  });
  const [bulkCreateForm, setBulkCreateForm] = useState({
    code: '',
    discount_type: 'percentage',
    discount_value: '',
    expiry_date: '',
    coupon_code_type: 'multiple',
    coupon_code_single_user_onetime: 0,
    minimum_purchase_amount: ''
  });
  const [creating, setCreating] = useState(false);
  const [bulkCreating, setBulkCreating] = useState(false);
  const [togglingCoupon, setTogglingCoupon] = useState(null);

  useEffect(() => {
    fetchCoupons();
    fetchBulkCoupons();
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredCoupons(coupons);
    } else {
      const filtered = coupons.filter(coupon => 
        coupon.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
        coupon.discount_type.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (coupon.coupon_code_type && coupon.coupon_code_type.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredCoupons(filtered);
    }
  }, [searchTerm, coupons]);

  useEffect(() => {
    if (bulkSearchTerm.trim() === '') {
      setFilteredBulkCoupons(bulkCoupons);
    } else {
      const filtered = bulkCoupons.filter(coupon => 
        coupon.code.toLowerCase().includes(bulkSearchTerm.toLowerCase()) ||
        coupon.discount_type.toLowerCase().includes(bulkSearchTerm.toLowerCase()) ||
        (coupon.coupon_code_type && coupon.coupon_code_type.toLowerCase().includes(bulkSearchTerm.toLowerCase()))
      );
      setFilteredBulkCoupons(filtered);
    }
  }, [bulkSearchTerm, bulkCoupons]);

  const fetchCoupons = async () => {
    try {
      setLoading(true);
      const response = await axios.get('https://gokulnair.com/new_project/api/coupons');
      setCoupons(response.data);
      setFilteredCoupons(response.data);
    } catch (err) {
      setError('Failed to fetch coupons');
      console.error('Error fetching coupons:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchBulkCoupons = async () => {
    try {
      setBulkLoading(true);
      const response = await axios.get('https://gokulnair.com/rpo_bulk/api/coupons');
      setBulkCoupons(response.data);
      setFilteredBulkCoupons(response.data);
    } catch (err) {
      setBulkError('Failed to fetch bulk coupons');
      console.error('Error fetching bulk coupons:', err);
    } finally {
      setBulkLoading(false);
    }
  };

  const handleCreateFormChange = (e) => {
    setCreateForm({
      ...createForm,
      [e.target.name]: e.target.value
    });
  };

  const handleBulkCreateFormChange = (e) => {
    setBulkCreateForm({
      ...bulkCreateForm,
      [e.target.name]: e.target.value
    });
  };

  const handleCreateCoupon = async (e) => {
    e.preventDefault();
    setCreating(true);

    try {
      const response = await axios.post('https://gokulnair.com/new_project/api/admin/add-coupon', {
        code: createForm.code,
        discount_type: createForm.discount_type,
        discount_value: parseFloat(createForm.discount_value),
        expiry_date: createForm.expiry_date,
        coupon_code_type: createForm.coupon_code_type,
        coupon_code_single_user_onetime: createForm.coupon_code_type === 'single' ? createForm.coupon_code_single_user_onetime : 0,
        minimum_purchase_amount: createForm.minimum_purchase_amount ? parseFloat(createForm.minimum_purchase_amount) : null
      });

      if (response.data.message === 'Coupon added successfully') {
        // Reset form and refresh coupons
        setCreateForm({
          code: '',
          discount_type: 'percentage',
          discount_value: '',
          expiry_date: '',
          coupon_code_type: 'multiple',
          coupon_code_single_user_onetime: 0,
          minimum_purchase_amount: ''
        });
        setShowCreateForm(false);
        fetchCoupons();
        alert('Coupon created successfully!');
      }
    } catch (err) {
      console.error('Error creating coupon:', err);
      alert('Failed to create coupon. Please try again.');
    } finally {
      setCreating(false);
    }
  };

  const handleBulkCreateCoupon = async (e) => {
    e.preventDefault();
    setBulkCreating(true);

    try {
      const response = await axios.post('https://gokulnair.com/rpo_bulk/api/admin/add-coupon', {
        code: bulkCreateForm.code,
        discount_type: bulkCreateForm.discount_type,
        discount_value: parseFloat(bulkCreateForm.discount_value),
        expiry_date: bulkCreateForm.expiry_date,
        coupon_code_type: bulkCreateForm.coupon_code_type,
        coupon_code_single_user_onetime: bulkCreateForm.coupon_code_type === 'single' ? bulkCreateForm.coupon_code_single_user_onetime : 0,
        minimum_purchase_amount: bulkCreateForm.minimum_purchase_amount ? parseFloat(bulkCreateForm.minimum_purchase_amount) : null
      });

      if (response.data.message === 'Coupon added successfully') {
        // Reset form and refresh bulk coupons
        setBulkCreateForm({
          code: '',
          discount_type: 'percentage',
          discount_value: '',
          expiry_date: '',
          coupon_code_type: 'multiple',
          coupon_code_single_user_onetime: 0,
          minimum_purchase_amount: ''
        });
        setShowBulkCreateForm(false);
        fetchBulkCoupons();
        alert('Bulk coupon created successfully!');
      }
    } catch (err) {
      console.error('Error creating bulk coupon:', err);
      alert('Failed to create bulk coupon. Please try again.');
    } finally {
      setBulkCreating(false);
    }
  };

  const getDiscountTypeText = (type) => {
    return type === 'percentage' ? 'Percentage' : 'Fixed Amount';
  };

  const handleToggleCoupon = async (couponId, currentStatus) => {
    try {
      setTogglingCoupon(couponId);
      const newStatus = currentStatus === 1 ? 0 : 1;
      
      const response = await axios.post('https://gokulnair.com/new_project/api/coupon/toggle', {
        coupon_id: couponId,
        is_active: newStatus
      });

      if (response.data.message) {
        // Update the coupon in the local state
        setCoupons(prev => 
          prev.map(coupon => 
            coupon.id === couponId 
              ? { ...coupon, is_active: newStatus }
              : coupon
          )
        );
        
        // Show success message
        alert(response.data.message);
      }
    } catch (err) {
      console.error('Error toggling coupon:', err);
      alert('Failed to toggle coupon status. Please try again.');
    } finally {
      setTogglingCoupon(null);
    }
  };

  const handleViewCouponUsage = (couponId) => {
    navigate(`/coupon-usage/${couponId}`);
  };

  const getActiveStatusText = (isActive) => {
    return isActive === 1 ? 'Active' : 'Inactive';
  };

  const getActiveStatusClass = (isActive) => {
    return isActive === 1 ? 'status-active' : 'status-inactive';
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };



  if (loading) {
    return (
      <Layout>
        <div className="loading">Loading coupons...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="coupons-content">
        {error && <div className="error-message">{error}</div>}
        
        <div className="coupons-header">
          <div className="header-left">
            <h1>Coupons Management</h1>
            <p>Manage discount coupons for your store</p>
          </div>
          <div className="header-actions">
            {activeTab === 'weight-loss' && (
              <button 
                className="create-coupon-btn"
                onClick={() => setShowCreateForm(!showCreateForm)}
              >
                {showCreateForm ? 'Cancel' : '+ Create RPO Weight Loss Coupon'}
              </button>
            )}
            {activeTab === 'bulk' && (
              <button 
                className="create-coupon-btn"
                onClick={() => setShowBulkCreateForm(!showBulkCreateForm)}
              >
                {showBulkCreateForm ? 'Cancel' : '+ Create RPO Bulk Coupon'}
              </button>
            )}
          </div>
        </div>

        {/* Tabs */}
        <div className="coupons-tabs">
          <button
            className={`tab-button ${activeTab === 'weight-loss' ? 'active' : ''}`}
            onClick={() => setActiveTab('weight-loss')}
          >
            RPO Weight Loss
          </button>
          <button
            className={`tab-button ${activeTab === 'bulk' ? 'active' : ''}`}
            onClick={() => setActiveTab('bulk')}
          >
            RPO Bulk
          </button>
        </div>

        {showCreateForm && (
          <div className="create-coupon-form">
            <div className="form-header">
              <h2>Create New Coupon</h2>
              <p>Fill in the details below to create a new discount coupon</p>
            </div>
            <form onSubmit={handleCreateCoupon}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="code">Coupon Code</label>
                  <input
                    type="text"
                    id="code"
                    name="code"
                    value={createForm.code}
                    onChange={handleCreateFormChange}
                    required
                    placeholder="e.g., WELCOME20"
                    maxLength="20"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="discount_type">Discount Type</label>
                  <select
                    id="discount_type"
                    name="discount_type"
                    value={createForm.discount_type}
                    onChange={handleCreateFormChange}
                    required
                  >
                    <option value="percentage">Percentage</option>
                    <option value="fixed">Fixed Amount</option>
                  </select>
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="discount_value">
                    Discount Value {createForm.discount_type === 'percentage' ? '(%)' : '($)'}
                  </label>
                  <input
                    type="number"
                    id="discount_value"
                    name="discount_value"
                    value={createForm.discount_value}
                    onChange={handleCreateFormChange}
                    required
                    placeholder={createForm.discount_type === 'percentage' ? '20' : '10.00'}
                    min="0"
                    step={createForm.discount_type === 'percentage' ? '1' : '0.01'}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="expiry_date">Expiry Date (Optional)</label>
                  <input
                    type="date"
                    id="expiry_date"
                    name="expiry_date"
                    value={createForm.expiry_date}
                    onChange={handleCreateFormChange}
                    min={new Date().toISOString().split('T')[0]}
                  />
                  <small className="field-help">Leave empty if no expiry date required</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="minimum_purchase_amount">Minimum Purchase Amount (Optional)</label>
                  <input
                    type="number"
                    id="minimum_purchase_amount"
                    name="minimum_purchase_amount"
                    value={createForm.minimum_purchase_amount}
                    onChange={handleCreateFormChange}
                    placeholder="50.00"
                    min="0"
                    step="0.01"
                  />
                  <small className="field-help">Leave empty if no minimum purchase required</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="coupon_code_type">Usage Type</label>
                  <select
                    id="coupon_code_type"
                    name="coupon_code_type"
                    value={createForm.coupon_code_type}
                    onChange={handleCreateFormChange}
                    required
                  >
                    <option value="multiple">Multiple Time Use</option>
                    <option value="single">Single Time Use</option>
                  </select>
                </div>
              </div>

              {createForm.coupon_code_type === 'single' && (
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="coupon_code_single_user_onetime">Single User Restriction</label>
                    <select
                      id="coupon_code_single_user_onetime"
                      name="coupon_code_single_user_onetime"
                      value={createForm.coupon_code_single_user_onetime}
                      onChange={handleCreateFormChange}
                      required
                    >
                      <option value={0}>Every user can use once</option>
                      <option value={1}>Only one user can use once</option>
                    </select>
                  </div>
                </div>
              )}
              
              <div className="form-actions">
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={creating}
                >
                  {creating ? 'Creating...' : 'Create Coupon'}
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Bulk Create Coupon Form */}
        {showBulkCreateForm && (
          <div className="create-coupon-form">
            <div className="form-header">
              <h2>Create New RPO Bulk Coupon</h2>
              <p>Fill in the details below to create a new bulk discount coupon</p>
            </div>
            <form onSubmit={handleBulkCreateCoupon}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="bulk_code">Coupon Code</label>
                  <input
                    type="text"
                    id="bulk_code"
                    name="code"
                    value={bulkCreateForm.code}
                    onChange={handleBulkCreateFormChange}
                    required
                    placeholder="e.g., BULK20"
                    maxLength="20"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="bulk_discount_type">Discount Type</label>
                  <select
                    id="bulk_discount_type"
                    name="discount_type"
                    value={bulkCreateForm.discount_type}
                    onChange={handleBulkCreateFormChange}
                    required
                  >
                    <option value="percentage">Percentage</option>
                    <option value="fixed">Fixed Amount</option>
                  </select>
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="bulk_discount_value">
                    Discount Value {bulkCreateForm.discount_type === 'percentage' ? '(%)' : '($)'}
                  </label>
                  <input
                    type="number"
                    id="bulk_discount_value"
                    name="discount_value"
                    value={bulkCreateForm.discount_value}
                    onChange={handleBulkCreateFormChange}
                    required
                    placeholder={bulkCreateForm.discount_type === 'percentage' ? '20' : '10.00'}
                    min="0"
                    step={bulkCreateForm.discount_type === 'percentage' ? '1' : '0.01'}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="bulk_expiry_date">Expiry Date (Optional)</label>
                  <input
                    type="date"
                    id="bulk_expiry_date"
                    name="expiry_date"
                    value={bulkCreateForm.expiry_date}
                    onChange={handleBulkCreateFormChange}
                    min={new Date().toISOString().split('T')[0]}
                  />
                  <small className="field-help">Leave empty if no expiry date required</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="bulk_minimum_purchase_amount">Minimum Purchase Amount (Optional)</label>
                  <input
                    type="number"
                    id="bulk_minimum_purchase_amount"
                    name="minimum_purchase_amount"
                    value={bulkCreateForm.minimum_purchase_amount}
                    onChange={handleBulkCreateFormChange}
                    placeholder="50.00"
                    min="0"
                    step="0.01"
                  />
                  <small className="field-help">Leave empty if no minimum purchase required</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="bulk_coupon_code_type">Usage Type</label>
                  <select
                    id="bulk_coupon_code_type"
                    name="coupon_code_type"
                    value={bulkCreateForm.coupon_code_type}
                    onChange={handleBulkCreateFormChange}
                    required
                  >
                    <option value="multiple">Multiple Time Use</option>
                    <option value="single">Single Time Use</option>
                  </select>
                </div>
              </div>

              {bulkCreateForm.coupon_code_type === 'single' && (
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="bulk_coupon_code_single_user_onetime">Single User Restriction</label>
                    <select
                      id="bulk_coupon_code_single_user_onetime"
                      name="coupon_code_single_user_onetime"
                      value={bulkCreateForm.coupon_code_single_user_onetime}
                      onChange={handleBulkCreateFormChange}
                      required
                    >
                      <option value={0}>Every user can use once</option>
                      <option value={1}>Only one user can use once</option>
                    </select>
                  </div>
                </div>
              )}
              
              <div className="form-actions">
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={bulkCreating}
                >
                  {bulkCreating ? 'Creating...' : 'Create Bulk Coupon'}
                </button>
              </div>
            </form>
          </div>
        )}

        {/* RPO Weight Loss Search Section */}
        {activeTab === 'weight-loss' && (
          <div className="search-section">
            <div className="search-container">
              <div className="search-icon">🔍</div>
              <input
                type="text"
                placeholder="Search RPO Weight Loss coupons by code, type, or usage..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
              {searchTerm && (
                <button 
                  onClick={() => setSearchTerm('')}
                  className="clear-search"
                >
                  ✕
                </button>
              )}
            </div>
            <div className="search-results">
              {searchTerm && (
                <p>Found {filteredCoupons.length} RPO Weight Loss coupon(s) matching "{searchTerm}"</p>
              )}
            </div>
          </div>
        )}

        {/* RPO Bulk Search Section */}
        {activeTab === 'bulk' && (
          <div className="search-section">
            <div className="search-container">
              <div className="search-icon">🔍</div>
              <input
                type="text"
                placeholder="Search RPO Bulk coupons by code, type, or usage..."
                value={bulkSearchTerm}
                onChange={(e) => setBulkSearchTerm(e.target.value)}
                className="search-input"
              />
              {bulkSearchTerm && (
                <button 
                  onClick={() => setBulkSearchTerm('')}
                  className="clear-search"
                >
                  ✕
                </button>
              )}
            </div>
            <div className="search-results">
              {bulkSearchTerm && (
                <p>Found {filteredBulkCoupons.length} RPO Bulk coupon(s) matching "{bulkSearchTerm}"</p>
              )}
            </div>
          </div>
        )}

        {/* RPO Weight Loss Coupons Section */}
        {activeTab === 'weight-loss' && (
          <div className="coupons-section">
            <h2>RPO Weight Loss Coupons ({filteredCoupons.length})</h2>
            {loading ? (
              <div className="loading">Loading RPO Weight Loss coupons...</div>
            ) : error ? (
              <div className="error">{error}</div>
            ) : (
              <div className="coupons-grid">
                {filteredCoupons.length === 0 ? (
                  <div className="no-coupons">
                    <p>{searchTerm ? `No RPO Weight Loss coupons found matching "${searchTerm}"` : 'No RPO Weight Loss coupons found. Create your first coupon!'}</p>
                  </div>
                ) : (
                  filteredCoupons.map((coupon) => (
                    <div key={coupon.id} className="coupon-card">
                      <div className="coupon-header">
                        <div className="coupon-code">
                          <h3>{coupon.code}</h3>
                          <span className={`status-badge ${getActiveStatusClass(coupon.is_active)}`}>
                            {getActiveStatusText(coupon.is_active)}
                          </span>
                        </div>
                        <div className="coupon-discount">
                          <span className="discount-value">
                            {coupon.discount_type === 'percentage' ? `${coupon.discount_value}%` : `$${coupon.discount_value}`}
                          </span>
                          <span className="discount-type">{getDiscountTypeText(coupon.discount_type)}</span>
                        </div>
                      </div>
                      
                      <div className="coupon-details">
                        <div className="detail-item">
                          <label>Usage Type:</label>
                          <span className={`usage-type ${coupon.coupon_code_type || 'legacy'}`}>
                            {coupon.coupon_code_type === 'single' ? 'Single Time Use' : 
                             coupon.coupon_code_type === 'multiple' ? 'Multiple Time Use' : 'Legacy Coupon'}
                          </span>
                        </div>
                        {coupon.coupon_code_type === 'single' && (
                          <div className="detail-item">
                            <label>Restriction:</label>
                            <span className={`restriction-type ${coupon.coupon_code_single_user_onetime === '1' ? 'one-user' : 'all-users'}`}>
                              {coupon.coupon_code_single_user_onetime === '1' ? 'Only one user can use once' : 'Every user can use once'}
                            </span>
                          </div>
                        )}
                        <div className="detail-item">
                          <label>Expiry Date:</label>
                          <span>{formatDate(coupon.expiry_date)}</span>
                        </div>
                        <div className="detail-item">
                          <label>Created:</label>
                          <span>{formatDate(coupon.created_at)}</span>
                        </div>
                      </div>
                      
                      <div className="coupon-actions">
                        <button
                          onClick={() => handleToggleCoupon(coupon.id, coupon.is_active)}
                          disabled={togglingCoupon === coupon.id}
                          className={`toggle-btn ${coupon.is_active ? 'deactivate' : 'activate'}`}
                        >
                          {togglingCoupon === coupon.id ? 'Updating...' : 
                           coupon.is_active ? 'Deactivate' : 'Activate'}
                        </button>
                        <button
                          onClick={() => handleViewCouponUsage(coupon.id)}
                          className="view-usage-btn"
                          title="View orders that used this coupon"
                        >
                          📊 View Usage
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        )}

        {/* RPO Bulk Coupons Section */}
        {activeTab === 'bulk' && (
          <div className="coupons-section">
            <h2>RPO Bulk Coupons ({filteredBulkCoupons.length})</h2>
            {bulkLoading ? (
              <div className="loading">Loading RPO Bulk coupons...</div>
            ) : bulkError ? (
              <div className="error">{bulkError}</div>
            ) : (
              <div className="coupons-grid">
                {filteredBulkCoupons.length === 0 ? (
                  <div className="no-coupons">
                    <p>{bulkSearchTerm ? `No RPO Bulk coupons found matching "${bulkSearchTerm}"` : 'No RPO Bulk coupons found. Create your first coupon!'}</p>
                  </div>
                ) : (
                  filteredBulkCoupons.map((coupon) => (
                    <div key={coupon.id} className="coupon-card">
                      <div className="coupon-header">
                        <div className="coupon-code">
                          <h3>{coupon.code}</h3>
                          <span className={`status-badge ${getActiveStatusClass(coupon.is_active)}`}>
                            {getActiveStatusText(coupon.is_active)}
                          </span>
                        </div>
                        <div className="coupon-discount">
                          <span className="discount-value">
                            {coupon.discount_type === 'percentage' ? `${coupon.discount_value}%` : `$${coupon.discount_value}`}
                          </span>
                          <span className="discount-type">{getDiscountTypeText(coupon.discount_type)}</span>
                        </div>
                      </div>
                      
                      <div className="coupon-details">
                        <div className="detail-item">
                          <label>Usage Type:</label>
                          <span className={`usage-type ${coupon.coupon_code_type || 'legacy'}`}>
                            {coupon.coupon_code_type === 'single' ? 'Single Time Use' : 
                             coupon.coupon_code_type === 'multiple' ? 'Multiple Time Use' : 'Legacy Coupon'}
                          </span>
                        </div>
                        {coupon.coupon_code_type === 'single' && (
                          <div className="detail-item">
                            <label>Restriction:</label>
                            <span className={`restriction-type ${coupon.coupon_code_single_user_onetime === '1' ? 'one-user' : 'all-users'}`}>
                              {coupon.coupon_code_single_user_onetime === '1' ? 'Only one user can use once' : 'Every user can use once'}
                            </span>
                          </div>
                        )}
                        <div className="detail-item">
                          <label>Expiry Date:</label>
                          <span>{formatDate(coupon.expiry_date)}</span>
                        </div>
                        <div className="detail-item">
                          <label>Created:</label>
                          <span>{formatDate(coupon.created_at)}</span>
                        </div>
                      </div>
                      
                      <div className="coupon-actions">
                        <button
                          onClick={() => handleToggleCoupon(coupon.id, coupon.is_active)}
                          disabled={togglingCoupon === coupon.id}
                          className={`toggle-btn ${coupon.is_active ? 'deactivate' : 'activate'}`}
                        >
                          {togglingCoupon === coupon.id ? 'Updating...' : 
                           coupon.is_active ? 'Deactivate' : 'Activate'}
                        </button>
                        <button
                          onClick={() => handleViewCouponUsage(coupon.id)}
                          className="view-usage-btn"
                          title="View orders that used this coupon"
                        >
                          📊 View Usage
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        )}


      </div>
    </Layout>
  );
};

export default Coupons; 